import { UpdateProductFlagsMutationVariables } from "@/api/hasura/generated/graphql"
import { HasuraMutations } from "@/api/hasura/mutations"
import { useMutation } from "@/api/utils/useQuery"
import { MutationResult } from "@/api/utils/types"

export interface IProductMutator {
  update(): MutationResult<UpdateProductFlagsMutationVariables>
}

export class ProductMutatorClass implements IProductMutator {
  update(): MutationResult<UpdateProductFlagsMutationVariables> {
    return useMutation({
      ...HasuraMutations.product.updateFeatureFlags(),
      serializerFn: (data) => data,
      invalidateCache: false,
    })
  }
}

export const ProductMutator = new ProductMutatorClass()
